export default __webpack_public_path__ + "static/media/doc4.e1a1b145.jpg";